import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/virtual/start',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-virtual-start" */ '~/pages/virtual/start'
        )
    ),
  },
  {
    path: '/virtual/feedback',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-virtual-feedback" */ '~/pages/virtual/feedback'
        )
    ),
  },
  {
    path: '/virtual/task',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-virtual-task" */ '~/pages/virtual/task'
        )
    ),
  },
  {
    path: '/virtual/task/desc',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-virtual-task-desc" */ '~/pages/virtual/task/desc'
        )
    ),
  },
] as RouteConfig[]
